const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 368,
    width: 368,
    id: "Layer_1",
    viewBox: "0 0 368 368",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CE0FF"
    },
    d: "M306,14c17.6,0,32,14.4,32,32v224c0,17.6-14.4,32-32,32H18c-17.6,0-32-14.4-32-32V46   c0-17.6,14.4-32,32-32H306L306,14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D440"
    },
    d: "M334,178.8l-47.6-47.6c-3.2-3.2-8-3.2-11.2,0l-96.8,95.2l-60-56.4L-0.8,296.8h336L334,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62C418"
    },
    d: "M177.2,222.8l-52.4-50.4c-3.2-3.2-8-3.2-11.2,0L-10,294h120L177.2,222.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F961D"
    },
    d: "M132,278c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8,0-11.2l8-8c3.2-3.2,8-3.2,11.2,0c3.2,3.2,3.2,8,0,11.2    l-8,8C136,277.2,134,278,132,278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F961D"
    },
    d: "M-1.2,293.2c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8.4,0-11.2L108.8,166c3.2-3.2,7.2-4.8,11.2-4.8    s8.4,1.6,11.2,4.8l46.4,46.4c3.2,3.2,3.2,8,0,11.2s-8,3.2-11.2,0L120,177.2L4.4,290.8C2.8,292.4,0.8,293.2-1.2,293.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F971D"
    },
    d: "M156.8,252.8c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8,0-11.2l118.4-117.6c6.4-6.4,16-6.4,22.4,0   l47.6,47.6c3.2,3.2,3.2,8,0,11.2s-8,3.2-11.2,0l-47.6-47.6L162.4,250.4C160.8,252,158.8,252.8,156.8,252.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62A2DD"
    },
    d: "M306,310H18c-22,0-40-18-40-40V46C-22,24-4,6,18,6h288c22,0,40,18,40,40v224   C346,292,328,310,306,310z M18,22C4.8,22-6,32.8-6,46v224c0,13.2,10.8,24,24,24h288c13.2,0,24-10.8,24-24V46c0-13.2-10.8-24-24-24   H18z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE53C"
    },
    cx: 66,
    cy: 94,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D933"
    },
    d: "M66,118c13.2,0,24-10.8,24-24S79.2,70,66,70C66,94,66,99.6,66,118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C39215"
    },
    d: "M66,126c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32S83.6,126,66,126z M66,78   c-8.8,0-16,7.2-16,16s7.2,16,16,16s16-7.2,16-16S74.8,78,66,78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePhoto);
export default __webpack_public_path__ + "static/media/image-photo.e53ec2f0e0c4b5293948181b808d4ccb.svg";
export { ForwardRef as ReactComponent };